import Axios from "axios";
import { useQuery } from "react-query";
import { caseKeys } from "src/query-keys";
import { Case, CaseBase } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: CaseBase | Case): CaseBase | Case {
  return {
    ...data,
    dateCreated: new Date(data.dateCreated),
  };
}
export function useCases(refetchInterval = false as false | number) {
  async function queryFn(): Promise<CaseBase[]> {
    const response = await Axios.get("/planning-api/cases");
    return response.data.map(deserialize);
  }

  return useQuery(caseKeys.all, () => queryFn(), { refetchInterval });
}
